import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import { addGoDaddyAccount, verifyGoDaddyCred } from "../../api/requests";
import LoadingButton from "@mui/lab/LoadingButton";
import { useSelector } from "react-redux";

export default function CreateAccountDialog({ open, setOpen }) {
  const [apiKeyValue, setApiKeyValue] = useState("");
  const [apiSecretValue, setApiSecretValue] = useState("");
  const [customerIdValue, setCustomerIdValue] = useState("");

  const [isValidCreds, setIsValidCreds] = useState(true);
  const [isVerifiedCalled, setIsVerifiedCalled] = useState(false);
  const [loadingVerify, setLoadingVerify] = useState(false);
  const [loadingAddCred, setLoadingAddCred] = useState(false);

  const token = useSelector((state) => state.auth.token);

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddAccount = async () => {
    const res = await addGoDaddyAccount(
      token,
      apiKeyValue,
      apiSecretValue,
      customerIdValue
    );
    if (res) {
      alert("GoDaddy account was added successfully");
    } else {
      alert("Failed adding new GoDaddy account");
    }
    return res;
  };

  const handleSubmitAndClose = async (event) => {
    event.preventDefault();
    const isValid = await handleVerify();
    if (!isValid) {
      return;
    }
    setLoadingAddCred(true);
    const res = await handleAddAccount();
    setLoadingAddCred(false);
    if (res) {
      setOpen(false);
      setApiKeyValue("");
      setApiSecretValue("");
      setCustomerIdValue("");
    }
  };

  const handleVerify = async () => {
    if (!isVerifiedCalled) {
      setIsVerifiedCalled(true);
    }
    setLoadingVerify(true);
    const res = await verifyGoDaddyCred(
      token,
      apiKeyValue,
      apiSecretValue,
      customerIdValue
    );
    setLoadingVerify(false);
    if (res) {
      setIsValidCreds(true);
    } else {
      setIsValidCreds(false);
    }
    return !!res;
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add Account</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Fill In Account Credentials here.
          </DialogContentText>
          <Box
            component="form"
            onSubmit={handleSubmitAndClose}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="apiKey"
              label="API Key"
              name="apiKey"
              autoComplete="apiKey"
              autoFocus
              value={apiKeyValue}
              onChange={(e) => {
                setApiKeyValue(e.target.value);
              }}
              error={!isValidCreds}
              helperText={
                !isValidCreds
                  ? "Credentials are not verified"
                  : isVerifiedCalled
                  ? "Credentials Verified"
                  : ""
              }
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="apiSecret"
              label="API Secret"
              name="apiSecret"
              autoComplete="apiSecret"
              value={apiSecretValue}
              onChange={(e) => {
                setApiSecretValue(e.target.value);
              }}
              error={!isValidCreds}
              helperText={
                !isValidCreds
                  ? "Credentials are not verified"
                  : isVerifiedCalled
                  ? "Credentials Verified"
                  : ""
              }
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="customerId"
              label="Customer ID"
              name="customerId"
              autoComplete="customerId"
              value={customerIdValue}
              onChange={(e) => {
                setCustomerIdValue(e.target.value);
              }}
              error={!isValidCreds}
              helperText={
                !isValidCreds
                  ? "Credentials are not verified"
                  : isVerifiedCalled
                  ? "Credentials Verified"
                  : ""
              }
            />

            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <LoadingButton loading={loadingVerify} onClick={handleVerify}>
                Verify-Account
              </LoadingButton>
              {isValidCreds && isVerifiedCalled && (
                <LoadingButton loading={loadingAddCred} type="submit">
                  Add-Account
                </LoadingButton>
              )}
            </DialogActions>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}
